import type { PagesConfig } from '#types/config/pages'

export default {
  brandClasses: {
    submitButton: 'w-full md:w-a'
  },
  interestOnlyForSubscription: {
    requiredLocales: [
      'cs-cz',
      'da-dk',
      'de-at',
      'de-be',
      'de-ch',
      'de-de',
      'de-lu',
      'en-ch',
      'en-cz',
      'en-dk',
      'en-fi',
      'en-gb',
      'en-ie',
      'en-lu',
      'en-se',
      'es-es',
      'fr-be',
      'fr-ch',
      'fr-fr',
      'fr-lu',
      'it-ch',
      'it-it',
      'nl-be',
      'nl-lu',
      'nl-nl',
      'pl-pl',
      'pt-pt',
      'sv-fi',
      'sv-se'
    ]
  },
  newsletters: [{
    type: 'newsletter'
  }, {
    type: 'loyaltyNewsletter',
    onlyForLoyaltyMember: true,
    requiredLocales: [
      'en-gb',
      'en-ie',
      'it-it',
      'nl-nl',
      'de-de',
      'fr-fr',
      'nl-nl',
      'es-es',
    ]
  }],
  showPostalCode: {
    requiredLocales: [
      'en-us',
      'en-ca',
      'fr-ca'
    ]
  },
} satisfies PagesConfig['profile']
